import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { reinitPlayerPlaylog } from '../../services'
import { ReinitPlayerPlaylogResponse } from '../../../type'

type ReinitPlaylogVariables = {
	playerId: string
	initSessionLogId: string
}

export default function useMutationReinitPlaylog(
	props?: UseBaseMutationOptions<
		ReinitPlayerPlaylogResponse,
		ReinitPlaylogVariables
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.ReinitPlaylog],
		mutationFn: (payload: ReinitPlaylogVariables) =>
			reinitPlayerPlaylog(payload.playerId, payload.initSessionLogId),
		...props,
	})
}
